export const validator = {
  checkNullValue(filed, value, cb) {
    if (!value) {
      return cb(new Error(`此选项不能为空`))
    }
    cb()
  },
  // 校验联系电话
  checkPhone(filed, value, cb) {
    if (!value) {
      return cb(new Error(`请输入联系电话`))
    }
    let reguPhone = /^((13[0-9])|(14[0,5,6,7,9])|(15([0-3]|[5-9]))|(16([6,7]))|(17([1-3]|[5-8]))|(18[0-9])|(19[1,3,5,8,9]))\d{8}$/
    if (value && !(reguPhone.test(value))) {
      return cb(new Error('请输入正确联系电话'))
    }
    cb()
  }
}
